<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" [routerLink]="['/productos']">
        <img src="../../../assets/img/logo.png" width="150" alt="" loading="lazy">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
                <a class="nav-link opcion" (click)="salirCatalogo()"><i class="fa fa-home" aria-hidden="true"></i>  Inicio <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item" routerLinkActive="active">
                <a class="nav-link opcion" [routerLink]="['/productos']"><i class="fa fa-book" aria-hidden="true"></i> Catálogo</a>
            </li>
            <li class="nav-item" routerLinkActive="active" *ngIf="user$ | async as user;">
                <a class="nav-link opcion" [routerLink]="['/pedidos']"><i class="fa fa-list" aria-hidden="true"></i> Mis Pedidos</a>
            </li>
            <li class="nav-item" routerLinkActive="active" *ngIf="user$ | async as user;">
                <a class="nav-link opcion" [routerLink]="['/perfil']"><i class="fa fa-user" aria-hidden="true"></i> Mi Perfil</a>
            </li>
            <li class="nav-item" routerLinkActive="active" *ngIf="user$ | async as user;">
                <a class="nav-link opcion" (click)="onLogout()"><i class="fa fa-sign-out" aria-hidden="true"></i> Salir</a>
            </li>
        </ul>
        <div class="user" *ngIf="user$ | async as user;else showLogin">
            <a class="btn btn-outline-danger mr-2" (click)="onLogout()" routerLinkActive="router-link-active">{{nombre | titlecase}}</a>
        </div>
        <ng-template #showLogin>
            <a routerLink="/login" routerLinkActive="active">
                <a class="btn btn-outline-danger" [routerLink]="['/home']" routerLinkActive="router-link-active">INGRESAR</a>
            </a>
        </ng-template>
        <div class="text-right">
            <button class="carsec" title="Carrito de compras" (click)="openCar()">                
                <i class="fa fa-shopping-cart fa-2x"></i>
                <span class="badge badge-primary intermitente">{{cantidad$}}</span>  
            </button>
        </div>
    </div>
</nav>